// IconTooltipButton.js

import React, { useState } from 'react';
import { Tip, Box, Text } from "grommet";
import * as Icons from "grommet-icons";

const IconTooltipButton = (props) => {
    const {doOnClick, iconName, iconColor, borderColor, size, tip} = props;
    const [borderSize, setBorderSize] = useState('xsmall');

    // Function to get the icon component based on the name
    const IconComponent = Icons[iconName];

    // Parse size to number and subtract 4px
    const iconSize = parseInt(size, 10) - 12;

    return (

        <Tip  
            content={<Box style={{
                fontWeight: "bold",
                background: "WhiteSmoke",
            //    background: "rgba(204, 204, 204, .6)",
                border: `1px solid ${borderColor}`, 
                padding: "5px",  
                borderRadius: "8px", 
                color: `${borderColor}`}}>
                {tip}
                </Box>}
            plain
        >
        <Box pad="xxsmall" width={size} height={size} align="center" round={true} justify="center"
            hoverIndicator 
            border={{ color: `${borderColor}`, size: `${borderSize}`}}
            style= {{                
                background:  `radial-gradient(${iconColor} 50%, ${iconColor} 30%, ${borderColor} 90%)` 
                        
            }}            

            onMouseOver={() => {setBorderSize('2px');}}
            onMouseOut={() => {setBorderSize('xsmall');}}
            onClick={() => doOnClick(true)}
            >
            {IconComponent ? (
                <IconComponent color={`${borderColor}`} size={`${iconSize}px`} fill="none"/>
            ) : (
                   
                <Text 
                fill="horizontal"
                color= {`${borderColor}`}
                weight="bold" 
              //  textAlign="center"
                > {iconName}
                </Text>
                )}
        </Box>
    </Tip>  
  );
};

export default IconTooltipButton;